export const BUTTON_PHYSICAL_SIZES = {
    SM: 24,
    MD: 24,
    LG: 32,
};
export const BUTTON_SIZES = {
    DEFAULT: 'xs',
    LG: 'sm',
};
